import { render, staticRenderFns } from "./ViewDialogActions.vue?vue&type=template&id=b5e1ed94&scoped=true&"
import script from "./ViewDialogActions.vue?vue&type=script&lang=js&"
export * from "./ViewDialogActions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5e1ed94",
  null
  
)

export default component.exports